<p>empty-route works!</p>
